import React from "react";
import { SEO, MainLayout, PendingApproval } from "../../../components";

const PendingApprovalPage = () => {
  return (
    <>
      <SEO title="pending approval" />
      <MainLayout>
        <PendingApproval />
      </MainLayout>
    </>
  );
};

export default PendingApprovalPage;
